import MainPracticeScenario from './MainPracticeScenario';
import { constants } from '../../../../misc/helpers';

var alreadyStarted = false;

export default class MainPracticeScenarioStep2 {
	constructor(private mainScenario: MainPracticeScenario, private onDone: () => void, public showFailedAar: () => void) {
	}

	start() {
		this.step1ShowBleedingControlKitAudio();
	}

	private step1ShowBleedingControlKitAudio() {
		if(alreadyStarted) {
			return;
		}
		alreadyStarted = true;
		this.step1ShowBleedingControlKit();
		this.mainScenario.playSound('Step-2', '1', () => {

		});
	}

	private step1ShowBleedingControlKit() {
		var context = this;
		this.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedoutTimer, {
			dispatch: this.mainScenario.gameManager.customData.dispatch,
			onTimeRanOut: () => {
				this.showFailedAar();
			},
			isActive: true
		});
		context.mainScenario.gameManager.UiManager.hideaAllUis();
		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.Feedback, {message: 'Open the bleeding control kit and select PPE.'});
			context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, {
				onSelectionChanged: (index: number) => {
					if(!context.mainScenario.gameManager || !context.mainScenario.gameManager.UiManager) {
						return;
					}
					if(index === 2) {
						context.step2PPESelected();
					} else {
						context.step2PPENotSelected();
					}
				}
			});
	}

	private step2PPESelected() {
		var context = this;

		context.mainScenario.gameManager.UiManager.showUi(constants.InGameUINames.BleedingControlKit, {
			disablePPEButton: true
		});
		setTimeout(() => {
			if(!context.mainScenario.gameManager || !context.mainScenario.gameManager.UiManager) {
				return;
			}
			context.mainScenario.gameManager.UiManager.hideaAllUis();
		}, 0);
		context.mainScenario.playSequence('PutOnPPE', null, () => {
			context.mainScenario.aarWearPPE = true;
			context.onDone();
		});
		context.mainScenario.playSequence('VictimPlayLips');
		this.mainScenario.playSound('Step-2', '2', () => {
			context.mainScenario.playSequence('VictimStopLips');
		});
	}
	private step2PPENotSelected() {
		var context = this;
		context.mainScenario.gameManager.UiManager.hideUi(constants.InGameUINames.BleedingControlKit);
		this.mainScenario.showJITFeedback('This choice is incorrect', () => context.step1ShowBleedingControlKit());
	}
}